// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fiksucity-logo.dark[data-v-8c5ffa68] path.st0 {\n  fill: #fafafa !important;\n}\n.fiksucity-logo.dark[data-v-8c5ffa68] path.st1 {\n  fill: #50c5ff !important;\n}\n.fiksucity-logo.dark[data-v-8c5ffa68] path.st2 {\n  fill: #929292 !important;\n}\n", ""]);
// Exports
module.exports = exports;
